export const GLOBAL_MESSAGE_EVENT = 'erp4c-global-message';

/**
 * @typedef {Object} GlobalMessageDetail
 * @property {string} [id]
 * @property {'error'|'info'} kind
 * @property {string} message
 * @property {string} [occurredAt] ISO timestamp
 * @property {string} [path]
 * @property {string} [fullUrl]
 * @property {string} [httpMethod]
 * @property {string} [requestUrl]
 * @property {number} [httpStatus]
 * @property {string} [source] e.g. 'api' | 'react'
 * @property {string} [stack]
 * @property {string} [componentStack]
 */

/**
 * @param {GlobalMessageDetail} detail
 */
export function dispatchGlobalMessage(detail) {
  if (typeof window === 'undefined') return;
  const id = detail.id || `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
  const occurredAt = detail.occurredAt || new Date().toISOString();
  window.dispatchEvent(
    new CustomEvent(GLOBAL_MESSAGE_EVENT, {
      detail: { ...detail, id, occurredAt },
    })
  );
}

export function dispatchGlobalError(message, extra = {}) {
  if (message == null || String(message).trim() === '') return;
  dispatchGlobalMessage({
    kind: 'error',
    message: String(message),
    source: extra.source || 'app',
    ...extra,
  });
}

export function dispatchGlobalInfo(message, extra = {}) {
  if (message == null || String(message).trim() === '') return;
  dispatchGlobalMessage({
    kind: 'info',
    message: String(message),
    source: extra.source || 'app',
    ...extra,
  });
}

/**
 * @param {(detail: GlobalMessageDetail) => void} handler
 * @returns {() => void}
 */
export function subscribeGlobalMessages(handler) {
  if (typeof window === 'undefined') return () => {};
  const fn = (e) => {
    if (e && e.detail) handler(e.detail);
  };
  window.addEventListener(GLOBAL_MESSAGE_EVENT, fn);
  return () => window.removeEventListener(GLOBAL_MESSAGE_EVENT, fn);
}
